/* ==========================================================================
   Nude Project style footer — footer.js
   ========================================================================== */

(function () {
  "use strict";

  function initAll(root) {
    initCarousel(root);
    initAccordion(root);
    initNewsletter(root);
  }

  /* ---------------------------------------------------------------------
     Store carousel — autoplay + arrows + dots
     --------------------------------------------------------------------- */
  function initCarousel(root) {
    var carousel = root.querySelector("[data-nf-carousel]");
    if (!carousel) return;

    var track = carousel.querySelector("[data-nf-track]");
    var slides = Array.prototype.slice.call(carousel.querySelectorAll("[data-nf-slide]"));
    var dots = Array.prototype.slice.call(carousel.querySelectorAll("[data-nf-dot]"));
    var prevBtn = carousel.querySelector("[data-nf-prev]");
    var nextBtn = carousel.querySelector("[data-nf-next]");
    var storeNames = Array.prototype.slice.call(carousel.querySelectorAll("[data-nf-store-name]"));
    var storeAddresses = Array.prototype.slice.call(carousel.querySelectorAll("[data-nf-store-address]"));
    var storeHours = Array.prototype.slice.call(carousel.querySelectorAll("[data-nf-store-hours]"));

    if (!slides.length) return;

    var current = 0;
    var autoplayDelay = parseInt(carousel.dataset.autoplayDelay, 10) || 4000;
    var timer = null;

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      track.style.transform = "translateX(-" + current * 100 + "%)";

      dots.forEach(function (dot, i) {
        dot.classList.toggle("is-active", i === current);
      });

      /* Only one store-info panel is shown at a time, matched to the slide */
      storeNames.forEach(function (el, i) { el.hidden = i !== current; });
      storeAddresses.forEach(function (el, i) { el.hidden = i !== current; });
      storeHours.forEach(function (el, i) { el.hidden = i !== current; });
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      stopAutoplay();
      if (slides.length > 1) {
        timer = setInterval(next, autoplayDelay);
      }
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (prevBtn) prevBtn.addEventListener("click", function () { prev(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener("click", function () { next(); startAutoplay(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () { goTo(i); startAutoplay(); });
    });

    carousel.addEventListener("mouseenter", stopAutoplay);
    carousel.addEventListener("mouseleave", startAutoplay);

    goTo(0);
    startAutoplay();
  }

  /* ---------------------------------------------------------------------
     Accordion — closed by default, smooth height, only one open at a time,
     plus-to-minus icon animation is handled purely by CSS via .is-open
     --------------------------------------------------------------------- */
  function initAccordion(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll("[data-nf-accordion]"));
    if (!items.length) return;

    items.forEach(function (item) {
      var trigger = item.querySelector("[data-nf-accordion-trigger]");
      var panel = item.querySelector("[data-nf-accordion-panel]");
      if (!trigger || !panel) return;

      trigger.addEventListener("click", function () {
        var isOpen = item.classList.contains("is-open");

        items.forEach(function (other) {
          if (other === item) return;
          other.classList.remove("is-open");
          other.querySelector("[data-nf-accordion-trigger]").setAttribute("aria-expanded", "false");
          other.querySelector("[data-nf-accordion-panel]").style.maxHeight = null;
        });

        if (isOpen) {
          item.classList.remove("is-open");
          trigger.setAttribute("aria-expanded", "false");
          panel.style.maxHeight = null;
        } else {
          item.classList.add("is-open");
          trigger.setAttribute("aria-expanded", "true");
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    });

    /* Keep the open panel's max-height correct on resize (e.g. font loads) */
    window.addEventListener("resize", function () {
      items.forEach(function (item) {
        if (!item.classList.contains("is-open")) return;
        var panel = item.querySelector("[data-nf-accordion-panel]");
        if (panel) panel.style.maxHeight = panel.scrollHeight + "px";
      });
    });
  }

  /* ---------------------------------------------------------------------
     Newsletter — focus state + inline validation feedback
     --------------------------------------------------------------------- */
  function initNewsletter(root) {
    var form = root.querySelector("[data-nf-newsletter-form]");
    if (!form) return;

    var input = form.querySelector("input[type='email']");
    var row = form.querySelector("[data-nf-input-row]");

    if (input && row) {
      input.addEventListener("focus", function () { row.classList.add("is-focused"); });
      input.addEventListener("blur", function () { row.classList.remove("is-focused"); });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      document.querySelectorAll("[data-nf-root]").forEach(initAll);
    });
  } else {
    document.querySelectorAll("[data-nf-root]").forEach(initAll);
  }
})();
